import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import ArticlesGrid from '../components/ArticlesGrid';
import Pagination from '../components/Pagination';
import { useSiteData } from '../data/SiteDataContext';
import { VIDEOS_PATH } from '../../utils/video';

export const POSTS_PER_PAGE = 12;

// The front page lists articles only; Condoned Media videos have their own
// page, announced by a bold link above the grid on every listing page.
function VideosCallout() {
    return (
        <Link className="kind-switch-link kind-switch-link--videos" to={VIDEOS_PATH}>
            <span className="kind-switch-link__glyph" aria-hidden="true">▶</span>
            <span className="kind-switch-link__text">Condoned Media — Watch the videos</span>
            <span className="kind-switch-link__arrow" aria-hidden="true">→</span>
        </Link>
    );
}

function HomePage() {
    const { articles, status } = useSiteData();
    const params = useParams();
    const requestedPage = params.pageNum ? parseInt(params.pageNum, 10) : 1;

    const totalPages = Math.max(1, Math.ceil(articles.length / POSTS_PER_PAGE));
    const currentPage = Number.isFinite(requestedPage) ? requestedPage : 1;

    if (params.pageNum && (!Number.isFinite(requestedPage) || requestedPage < 2)) {
        return <Navigate to="/" replace />;
    }

    if (status === 'ready' && currentPage > totalPages) {
        return <Navigate to="/" replace />;
    }

    if (status === 'loading') {
        return (
            <>
                <VideosCallout />
                <p className="small-meta site-loading">Loading …</p>
            </>
        );
    }

    if (status === 'error') {
        return (
            <>
                <VideosCallout />
                <p className="small-meta site-loading">Failed to load documents. Refresh to retry.</p>
            </>
        );
    }

    const start = (currentPage - 1) * POSTS_PER_PAGE;
    const pagePosts = articles.slice(start, start + POSTS_PER_PAGE);

    return (
        <>
            <VideosCallout />
            <ArticlesGrid posts={pagePosts} />
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getPageLink={(page) => (page <= 1 ? '/' : `/page/${page}`)}
            />
        </>
    );
}

export default HomePage;
